import { Controller } from '@hotwired/stimulus';
import { enableDoneButtonIfLastIncompleteItem } from '../utils/enable_done_button_if_last_incomplete_item';

export default class ActionItemButtonFormController extends Controller {
  static targets = ['submitButton'];
  static values = {
    completedText: String
  };

  get submitButton() {
    return this.submitButtonTarget;
  }

  onSaveSuccess(data) {
    const payload = data.detail[0];
    const event = new CustomEvent('actionItemCard.saveSuccess', {
      detail: payload
    });
    document.dispatchEvent(event);
    enableDoneButtonIfLastIncompleteItem();

    // HACK: move this call to the bottom of the stack so that it runs after everything else
    setTimeout(this.disableButton.bind(this), 0);
  }

  disableButton() {
    this.submitButton.disabled = true;

    if (this.completedTextValue) {
      this.submitButton.value = this.completedTextValue;
    }
  }
}
